import { AxiosPromise } from "axios";
import { CONSTANT_CONFIG } from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/report/crop-wings-report`;
const endpoints = {
    getFinancialYearAndSeasonRiceTargetReport: () => `${RESOURCE_ENDPOINT}/financial-year-and-season-rice-production-target-report`,
    getLocationWiseCultivationAndProductionTargetReport: () => `${RESOURCE_ENDPOINT}/location-wise-cultivation-and-production-target-report`,
};

export default class CropsWingReportApi {
    public getFinancialYearAndSeasonRiceTargetReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getFinancialYearAndSeasonRiceTargetReport();
        return HttpService.get(url, params, headers);
    }

    public getLocationWiseCultivationAndProductionTargetReport = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getLocationWiseCultivationAndProductionTargetReport();
        return HttpService.get(url, params, headers);
    }
}
